import { ListChecks } from 'lucide-react'

import { areaTypeOptions, areaStatusOptions } from './constants/statusOptions'
import { SearchQuery } from './filter/SearchQuery'
import { SelectFilter } from './filter/SelectFilter'
import { useAreaFilters } from './hooks/useAreaFilters'
import { SelectionSummary } from './SelectionSummary'

export const FiltersRow = () => {
  // Use the nuqs-based filter hook
  const {
    filters,
    updateSearch,
    clearAllFilters,
    hasActiveFilters,
    updateAreaType,
    updateAreaStatus,
  } = useAreaFilters()

  const handleClearFilters = () => {
    // Clear nuqs filters
    clearAllFilters()
  }

  // Check if any filters are active - now only using nuqs filters
  const hasAnyActiveFilters = hasActiveFilters

  return (
    <div className="mb-2">
      <div className="flex flex-col gap-4">
        <div className="flex flex-wrap items-center gap-2">
          <SearchQuery
            searchQuery={filters.search}
            onSearchChange={updateSearch}
            placeholder="Buscar por nombre de área..."
          />

          <SelectFilter
            title="Tipo"
            placeholder="Buscar tipo..."
            activeSelections={filters.type}
            onSelectionsChange={updateAreaType}
            selectionOptions={areaTypeOptions}
            searchActive={false}
            icon={<ListChecks className="h-4 w-4" />}
          />

          <SelectFilter
            title="Estado"
            placeholder="Buscar estado..."
            activeSelections={filters.isActive}
            onSelectionsChange={updateAreaStatus}
            selectionOptions={areaStatusOptions}
            searchActive={false}
            icon={<ListChecks className="h-4 w-4" />}
          />
        </div>

        {hasAnyActiveFilters && (
          <SelectionSummary
            // Active nuqs filters
            activeStatuses={filters.isActive}
            setActiveStatuses={updateAreaStatus}
            statusOptions={areaStatusOptions}
            searchQuery={filters.search}
            setSearchQuery={updateSearch}
            handleClearFilters={handleClearFilters}
            activeTypes={filters.type}
            setActiveTypes={updateAreaType}
            typeOptions={areaTypeOptions}
          />
        )}
      </div>
    </div>
  )
}
